import { render, staticRenderFns } from "./HandlerProfiles.vue?vue&type=template&id=d82492a0"
import script from "./HandlerProfiles.vue?vue&type=script&lang=ts"
export * from "./HandlerProfiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports